// @mui material components
import { Icon } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// React components
import MKBox from "components/MKBox";

// Images
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import { useNavigate } from "react-router-dom";
import imc24 from "assets/images/logo2.jpg";

function BriefAboutus() {
    const navigate = useNavigate();
    return (
        <MKBox component="section" py={6} my={6}>
            {/* <Container> */}
            <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
                <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
                    <Grid container spacing={3}>
                        <MKBox pt={12} pb={2} px={2} lineHeight={1}>
                            <MKTypography variant="h3" color="#fff" gutterBottom>
                                About IM Chess Academy & Club
                            </MKTypography>
                            <MKTypography variant="body2" color="black" opacity={0.8}>
                                IMChess Academy & Club is where you experience the 360° journey of chess — from learning the basics to competing at the highest levels. Our motive is simple yet powerful: to become a bridge for every chess enthusiast, helping them make the right moves both on the board and in life.
                            </MKTypography>
                            <MKTypography variant="body2" color="black" opacity={0.8}>
                                Founded and led by <b>International Master Manush Shah and Jimita Gandhi</b>, our academy brings together 22+ years of competitive playing experience and over 6 years of coaching dedication.
                            </MKTypography>
                            <MKTypography variant="body2" color="black" opacity={0.8}>
                                Together, we’ve built a proven track record of guiding students to success at the state, national, and international stages.
                            </MKTypography>
                        </MKBox>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: { xs: 0, md: 4 } }}>
                        <Grid item xs={12} md={6}>
                            <MKButton variant="gradient"
                                onClick={() => navigate('/about-us')}
                                color="info" sx={{
                                    width: "max-content",
                                    display: "flex",
                                    alignItems: "center",

                                    "& .material-icons-round": {
                                        transform: `translateX(3px)`,
                                        transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                                    },

                                    "&:hover .material-icons-round, &:focus .material-icons-round": {
                                        transform: `translateX(6px)`,
                                    },
                                }}>
                                Know More About Us <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                            </MKButton>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
                    <img
                        src={imc24}
                        alt="about-img"
                        style={{
                            width: "100%",  // Makes image width responsive to the container
                            height: "auto", // Maintains the aspect ratio of the image
                        }}
                    />
                </Grid>
            </Grid>
            {/* </Container> */}
        </MKBox>
    );
}

export default BriefAboutus;
